import React, {useState, useEffect, useRef} from 'react';
import Header from '../../Components/HeaderLogin';

import Campo from '../../Components/Campo';
import TextLink from '../../Components/TextLink';
import Butao from '../../Components/Butao';
import Select from '../../Components/Select';
import { Spinner  } from "react-awesome-spinners";
import CidadeJson from "../../JSONS/cidadejson";
import InstitutoJson from "../../JSONS/institutojson";
import TipocontaJson from "../../JSONS/tipocontjson";
import SweetAlert from 'react-bootstrap-sweetalert';
import Api from '../../Api';
import ReCAPTCHA from "react-google-recaptcha";




export default ({DadEmp, setConta, setEmail, Email, Senha, setSenha, 
  Confirsenha, setConfirsenha, Cidade, setCidade, Estado, 
  setEstado, Instituicao, setInstituicao, Nome, setNome, 
  Telefone, setTelefone,  ContaTipo, setContaTipo,
   Loading, cadastrando, logando, Alert, setAlert, NomeGuerra, setNomeGuerra,
   Patente, setPatente, Bo, setLoading, setIdUser}) => {

    const captcha = useRef(null)
   

          const [EstCidJson, setEstCidJson] = useState({CidadeJson});
          const [ListaEstado, setListaEstado] = useState([]);
          const [ListaCidade, setListaCidade] = useState([]);
          const [ListInst, setListInst] = useState(InstitutoJson.Intituicao);
          const [ListContaTipo, setListContaTipo] = useState(TipocontaJson.tipo);   
          const [VerManual, setVerManual] = useState(false);
          const [VerContato, setVerContato] = useState(false);
          const [CadasPag, setCadasPag] = useState(false);
          const [EsqSenhaServ, setEsqSenhaServ] = useState(false);
          const [CodLast, setCodLast] = useState(0);
          const [Tel, setTel] = useState("");
          const [Btn, setBtn] = useState("");
          const [Carreg, setCarreg] = useState(false);
          const [Cadast, setCadast] = useState(false);
          const [CodG, setCodG] = useState(false);
          const [Robo, setRobo] = useState(true);
          const [Tentativa, setTentativa] = useState(0)
          const [LisEmp, setLisEmp] = useState()
          const [NomeEmp, setNomeEmp] = useState("")
          const [ExistErro, setExistErro] = useState("")
          const [ListUser, setListUser] = useState([])
         const [IdGrav, setIdGrav] = useState("")
        
        
                  useEffect(() => {
                    ListandoEstado();
                  }, []);

                
                  
            
                 
                    useEffect(() => {
                     if (Email && !Email.includes("_")) {
                        TelWhats();
                      }
                      
                     }, [Email])

                     const TelWhats = ()=>{
                    
                      setLoading(true)
                      Api.GBVerWhats(setIdGrav, Email, setIdUser,  setListUser,  setBtn, setExistErro, setLoading)
                      //Api.AnaliseTel(Tel, setTe1, setNome)  
                     }

                    const onChange = ()=> {
                      if(captcha.current.getValue()){
                        setRobo(false)
                      }
                    }

                          const Entrarpainel= () => {
                            setConta("45564556");
                          }

                          const PegEmpresa = async (value) => {
                           console.log(value)
                           setNomeEmp(value)
                           for(let i in LisEmp){
                            if(LisEmp[i].select === value){
                              await localStorage.setItem('Empresa', LisEmp[i].id );
                              await localStorage.setItem('Url', LisEmp[i].Url );
                              console.log(LisEmp[i].id)
                            }
                           }
                          
                          }

                          function ListandoEstado() {
                            let list = [] ;
                            EstCidJson.CidadeJson.estados.forEach(result => {
                                  list.push({
                                      select: result.nome,
                                      cidades: result,
                                  });   
                            });
                            setListaEstado(list);
                          }

                          
                            function confirma() {
                              setAlert(" ");
                            }
                            function cancelar() {
                              setAlert(" ");
                            }

                            function recuperarSenha() {
                              setEsqSenhaServ(true);
                            }

                            // function betfair () {
                            //    new sportApi('betfair', { getCommonContents: false });
                            // }

                            const GerarCod =  async ()=> {
                              setLoading(true)
                              Api.Entrando2(Email, setCodLast, setCodG, setLoading,  setAlert);
    
                            }

                          

                            const EntrandoCont =  async ()=> {
                           
                              
                              if(Senha !== ""){
                              if(parseInt(Senha)  === CodLast){
                                setLoading(true)
                                
                                 await localStorage.setItem('Id', IdGrav);
                                 logando()
                              } else {
                                setTentativa(Tentativa +1)
                                setAlert("Código Errado "+(Tentativa+1)+"° tentativa de 3");
                              }
                              
                              } else {
                                 
                                setAlert("Preencha o Código");
                              }
                           
                             
                            }
                    
   
    return (
        <div>
           {/* <Header
            setAparercer={setVerManual} 
            Aparercer={VerManual} 
            setVerContato={setVerContato}
            VerContato={VerContato} 
            /> */}
           
          {VerManual === true &&
           <>
             
            </> 
           }

          {EsqSenhaServ === true &&
           <>
          
            </> 
           }


           {VerManual === false && EsqSenhaServ === false &&
                <div className="loginAdmin"> 
                {Alert !== " " &&
                  <SweetAlert danger title={Alert} confirmBtnBsStyle="danger" onConfirm={confirma} onCancel={cancelar} />
                }
                  
                  { CadasPag === false &&
                  <>
                  
                   <img className='imagem_top' src='../../assets/GBlogomarca.png' style={{ }} alt="" r/>
                    
                  <div className="quadroAcesso" >
                  <div className="caixaAcesso">
                   
                      <h3 className="tituloQuadro" >LOGIN ADM</h3>
                      {Tentativa >= 3 ?
                      <div className="alert alert-danger alert-dismissible">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                        <h5><i className="icon fas fa-ban"></i> AVISO!</h5>
                       3 tentativas erradas, atualize sua pagina e inicie novamente
                      </div>
                      :
                      <>
                       {CodG === true &&
                      <div className="alert alert-success alert-dismissible">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                        <h5><i className="icon fas fa-info"></i> ALERTA!</h5>
                        Seu Código foi enviado para o Whatsapp do Numero {Email}
                      </div>
                       }
                      </>
                       }    
                       {ExistErro &&

                            <div className="alert alert-danger alert-dismissible">
                              <button type="button" className="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                              <h5><i className="icon fas fa-ban"></i> AVISO!</h5>
                            {ExistErro}
                            </div>
                           }
                            {CodG === false?
                            <>
                 
                             
                            
                              <Campo 
                                type={"tel"}
                                placeholder={"Digite Whatsapp"}
                                icon={"fas fa-phone"}
                                value={Email}
                                onChange={e=>setEmail(e.target.value)}
                                mask={"(99)99999-9999"}
                                />
 
                              {Loading === true ?
                              <>
                              <img className='imagem_top5' src='../../assets/TACarreg.gif' style={{ }} alt="" /> 
                              </>  
                              :
                              <>
                               {Btn &&
                                <>
                              <Butao 
                              onClick={GerarCod}
                              text={"Gerar Código"}
                              /> 
                                </> 
                               }      
                              </> 
                                } 
                                
                            </>
                           
                            :
                            <>
                            
                             {Tentativa < 3 &&
                                  <>
                                   <Campo 
                                  type={"password"}
                                  placeholder={"Digite o Código"}
                                  icon={"fas fa-lock"}
                                  value={Senha}
                                  onChange={e=>setSenha(e.target.value)}
                                  mask={null}
                                    />
                                    {Loading === true ?
                              <>
                              <img className='imagem_top5' src='../../assets/TACarreg.gif' style={{ }} alt="" /> 
                              </>  
                              :
                              <>
                                <Butao 
                                  onClick={EntrandoCont}
                                  text={"Entrar"}
                                  /> 
                                  </>

                                }
                                  </>

                                }
                            </>
                            }
                               
                                  {CodLast !== 0 &&
                                  <>
                                  
                                  </>

                                  }
                                 
                                
                                <div className="quadroLink">

                                </div>
                            
                     </div>
                   
                    </div>
                    
                    </>
                    }

                 
                   
                </div>
                
            }
            
          </div>
    );
}